import { Heart, Sparkles, Users } from "lucide-react";

export const AboutUs = () => {
  return (
    <section
      id="sobre-nosotros"
      className="relative py-24 overflow-hidden scroll-mt-24 bg-gradient-to-b from-background via-secondary/20 to-background"
    >
      <div className="absolute top-1/4 left-0 w-72 h-72 rounded-full bg-primary/15 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-accent/15 blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-14 space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-primary/20">
            <Sparkles className="w-4 h-4 text-primary" aria-hidden />
            <span className="text-sm font-medium text-foreground">Sobre nosotros</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            En{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
              HABILY
            </span>{" "}
            creemos que comprar vivienda puede ser ilusionante
          </h2>
          <p className="text-lg text-muted-foreground">
            No un proceso lleno de dudas, presión e incertidumbre. Por eso existe GABI.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          <div className="glass rounded-3xl border border-primary/15 p-8 md:p-10 shadow-xl">
            <p className="text-lg text-muted-foreground leading-relaxed">
              Por eso nace <strong className="text-foreground">GABI</strong>, el Gestor y Analista de Bienes Inmuebles: una
              inteligencia artificial diseñada para acompañarte durante todo el proceso de compra de una vivienda,
              ayudándote a entender cada paso y a tomar decisiones con mayor seguridad.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="glass rounded-3xl border border-border/60 p-8 flex flex-col gap-4">
              <div className="w-12 h-12 rounded-2xl gradient-primary flex items-center justify-center">
                <Heart className="w-6 h-6 text-primary-foreground" aria-hidden />
              </div>
              <h3 className="text-xl font-bold">No somos una inmobiliaria tradicional</h3>
              <p className="text-muted-foreground leading-relaxed">
                No trabajamos para venderte una casa concreta. Trabajamos para ayudarte a{" "}
                <strong className="text-foreground">comprar bien</strong>.
              </p>
            </div>
            <div className="glass rounded-3xl border border-border/60 p-8 flex flex-col gap-4">
              <div className="w-12 h-12 rounded-2xl bg-accent/20 flex items-center justify-center border border-accent/30">
                <Users className="w-6 h-6 text-accent" aria-hidden />
              </div>
              <h3 className="text-xl font-bold">Detrás de GABI hay personas</h3>
              <p className="text-muted-foreground leading-relaxed">
                Un equipo de profesionales del sector inmobiliario, financiero y tecnológico que conocen de primera mano
                las dificultades de quien busca piso y comparten una idea: hacer el proceso más transparente, humano y
                sencillo.
              </p>
            </div>
          </div>

          <div className="glass rounded-3xl border border-primary/20 p-8 md:p-10 bg-gradient-to-br from-primary/5 to-accent/5">
            <p className="text-muted-foreground leading-relaxed mb-4">
              Combinamos tecnología, análisis financiero y experiencia real del sector para ofrecerte una visión objetiva
              y personalizada de cada operación. GABI analiza tu perfil financiero, te ayuda a entender qué vivienda
              puedes permitirte realmente, revisa oportunidades, detecta riesgos, estima gastos e impuestos, y te
              acompaña en aspectos clave como la hipoteca, la negociación o la documentación de compra.
            </p>
            <div className="rounded-2xl border border-border/50 bg-card/50 p-6 mt-6">
              <h3 className="text-lg font-semibold text-foreground mb-2">Nuestra misión es clara</h3>
              <p className="text-muted-foreground leading-relaxed">
                Dar certezas a quienes van a tomar una de las decisiones más importantes de su vida. Porque comprar una
                vivienda no debería depender solo de intuiciones, prisas o falta de información. Debería hacerse con{" "}
                <strong className="text-foreground">datos</strong>, <strong className="text-foreground">acompañamiento</strong>{" "}
                y <strong className="text-foreground">tranquilidad</strong>.
              </p>
            </div>
            <p className="mt-8 text-center text-lg font-medium bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
              Bienvenido a una nueva forma de comprar vivienda. Bienvenido a GABI.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
